import { render } from "./AlertasInventario.vue?vue&type=template&id=4b8b8400&scoped=true"
import script from "./AlertasInventario.vue?vue&type=script&lang=js"
export * from "./AlertasInventario.vue?vue&type=script&lang=js"

import "./AlertasInventario.vue?vue&type=style&index=0&id=4b8b8400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8b8400"]])

export default __exports__